import React, { useState } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../ReduxManager/actions";
import { Col, Row, Form } from "react-bootstrap";
import EyeSvg from "../../assets/images/svg/eye.svg";
import EyeHideSvg from "../../assets/images/svg/eye-hide.svg";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Swal from "sweetalert2";
import { useAuth } from "../../Context/auth/authContext";
import axiosInstance from "../../axios";
import config from "../../config";
import { jwtDecode } from 'jwt-decode';
import navigation from '../../menu-items';
import routes from "../../Routes/Routes";

const AuthLoginPage = ({ onAdminAuthorize }) => {
	// const [token, setToken] = useState(localStorage.getItem('token'));
	const navigate = useNavigate();
	const { handleUserData, handleToken } = useAuth();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [showPassword, setShowPassword] = useState(false);
	const [errors, setErrors] = useState({});


	// 🔥 Get first menu url dynamically
	const getFirstUrl = (items) => {
		for (let item of items) {
			if (item.url) return item.url;
			if (item.children) {
				const childUrl = getFirstUrl(item.children);
				if (childUrl) return childUrl;
			}
		}
		return null;
	};

	const defaultRoute = getFirstUrl(navigation.superItems) || "/dashboard"


	// ------------------------- ADMIN LOGIN ---------------------------
	const authenticate = async (e) => {
		e.preventDefault();
		const validationErrors = {};
		let emailFlag = false;
		let passwordFlag = false;
		if (!email) {
			validationErrors.email = "Email is required";
		} else {
			if (!/\S+@\S+\.\S+/.test(email)) {
				validationErrors.email = "Invalid email format";
			} else {
				emailFlag = true;
			}
		}
		if (!password) {
			validationErrors.password = "Password is required";
		} else {
			if (password.length < 6) {
				validationErrors.password =
					"Password must be at least 6 characters long";
			} else {
				if (!/(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/.test(password)) {
					validationErrors.password =
						"Password must contain at least one capital letter, one number, and one special character";
				} else {
					passwordFlag = true;
				}
			}
		}
		if (Object.keys(validationErrors).length === 0) {
			try {
				const body = {
					username: email,
					password: password,
				};
				const response = await axiosInstance.post(
					`${config.serverUrl}/admin/v1/loginUser`,
					body
				);
				// console.log("response===>", response.data);
				if (response.data.token) {
					// setToken(response.data.token)
					handleToken(response.data.token);
					// handleUserData(response.data.token);
					// -------- Token Convert In Date  --------
					const decodedToken = jwtDecode(response.data.token);
					const tokenExpiration = decodedToken.exp;
					const expirationDate = new Date(tokenExpiration * 1000);
					console.log("expirationDate", expirationDate);
					onAdminAuthorize(true, response.data.userId, expirationDate);
					setPassword("");
					setEmail("");
					navigate(defaultRoute);
					// axiosInstance.defaults.headers["Authorization"] =
					// 	"Bearer " + response.data.token;
					// axiosInstance.get(`/admin/v1/getAdminUserDetailsById/${response.data.userId}`).then((response) => {
					// 	// console.log("adminUserData=====>>>", response.data.data);
					// 	// setAdminUserData(response.data.data)
					// onAdminAuthorize(true, response.data.id, expirationDate, response.data.data.name, response.data.data.email,
					// 	response.data.data.currency, response.data.data.currency_code);
					// 	setPassword("");
					// 	setEmail("");
					// 		navigate(defaultRoute);
					// })
				}
			} catch (error) {
				console.log("err catch", error);
				setEmail("");
				setPassword("");
				Swal.fire({
					icon: "error",
					title: "Unauthorized User",
					text: "Please Enter valid Email and Password",
				});
			}
		}
		setErrors(validationErrors);
	};

	return (
		<div className="admin-login-page">
			<div className="main-login-card-container">
				<div className="login-card shadow">
					<div className="form-card p-4">
						{/* Top logo */}
						<div className="text-center mb-4">
							{/* <img src="/logo.svg" alt="Logo" height="40" /> */}
							Sevanest
						</div>

						{/* Headings */}
						<h4 className="text-center fw-bold mb-1">Welcome Back</h4>
						<p className="text-center text-muted mb-4">
							Enter your credentials to access your account.
						</p>

						{/* Form */}
						<Form onSubmit={authenticate}>
							<Form.Group controlId="email" className="mb-3">
								<Form.Control
									type="text"
									placeholder="Enter your email"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									className={`py-2 ${errors?.email && "validation-border"}`}
								/>
								{errors.email && (
									<span className="validationText">{errors.email}</span>
								)}
							</Form.Group>

							<Form.Group controlId="password" className="mb-3">
								<div className="position-relative">
									<Form.Control
										type={showPassword ? "text" : "password"}
										placeholder="Enter your password"
										value={password}
										onChange={(e) => setPassword(e.target.value)}
										className={`py-2 ${errors?.password && "validation-border"}`}
									/>
									<div
										className="eyeimage-logo"
										onClick={() => setShowPassword(!showPassword)}
									>
										{showPassword ? (
											<LazyLoadImage src={EyeHideSvg} alt="Hide" width={25} />
										) : (
											<LazyLoadImage src={EyeSvg} alt="Show" width={25} />
										)}
									</div>
									{errors.password && (
										<span className="validationText">{errors.password}</span>
									)}
								</div>
							</Form.Group>

							{/* Sign in button */}
							<div className="d-grid mb-3">
								<button type="submit" className="btn btn-primary py-2">
									Sign In
								</button>
							</div>
						</Form>

						{/* Reset Password */}
						<div className="text-center mt-3">
							<span className="text-muted">Forgot your password?</span>{" "}
							<a href="/reset-password" className="text-primary fw-semibold">
								Reset Password
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>

	);
};

const mapStateToProps = (state) => {
	return {
		isAuthenticated: state.isAuthorised,
		isAccessRights: state.accessRights,
	};
};


const mapDispatchToProps = (dispatch) => {
	return {
		onAdminAuthorize: (authstate, userId, authtoken) => dispatch({ type: actionTypes.ADMIN_AUTHORIZED, payload: { authState: authstate, userId: userId, authToken: authtoken } }),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthLoginPage);